import uuid from 'uuid'

export const mutations = {
  ['REFRESH_REMINDERS'](state) {
    state.refreshReminders = uuid()
  }
}

export const actions = {
  ['REFRESH_REMINDERS']({ commit }) {
    commit('REFRESH_REMINDERS')
  }
}
